<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.0255 23.9744L23.9745 8.02539" stroke="black" stroke-miterlimit="10"/>
<path d="M8.0255 8.02539L23.9745 23.9744" stroke="black" stroke-miterlimit="10"/>
</svg>
